import { Inject, Injectable } from '@angular/core';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { Config, StoreService } from '@ddt-web/store-service';
import { filter, first } from 'rxjs/operators';

import { AppStoreConfig } from '../models';

@Injectable()
export class StoreServiceHelper {
	constructor(private storeService: StoreService, @Inject(APP_STORE_CONFIG_TOKEN) public storeConfig: AppStoreConfig) { }

	/**
	 * Check if any the provided portfolios ids have failed analysis previously (errorCode or error or no valid children in associatedPortfolios)
	 * and if they did, remove them from the associatedPortfolios store so that API calls are made again
	 * (otherwise user is blocked on a page that will never load because no API call is made).
	 *
	 * If no none of the provided portfolio ids have failed before, nothing is done.
	 *
	 * @param ids ids of the selected portfolios to be analysed
	 */
	public removeFailedPortfoliosFromStore(ids: string[], storeConfig: Config<any> = this.storeConfig.associatedPortfolios): void {
		this.storeService.selectAll(storeConfig)
			.pipe(
				first(),
				filter(associatedPortfolios => associatedPortfolios && !associatedPortfolios.isLoading)
			)
			.subscribe(associatedPortfolios => {
				const failedPortfolios = ids.filter(id => {
					const portfolio = associatedPortfolios?.entities?.[id];
					return portfolio ? portfolio.errorCode || portfolio.error || !portfolio.children?.length : false; // if portfolio has error or empty children (all children are missing when tax migration is enabled)
				});
				if (failedPortfolios.length) {
					this.storeService.removeMany(storeConfig, failedPortfolios);
				}
			});
	}
}
